import Image from 'next/image'
import { sanitizeHTML } from "@/lib/utils";
import { getReadableImageUrl } from "@/lib/directus";

interface GoToVideoStoriesData {
  published?: boolean;
  heading?: {
    text?: string;
    title?: string;
  };
  button?: {
    label?: string;
    href?: string;
  };
  video?: {
    id: string;
    filename_download: string;
  };
}

export const fields = [
  'published',
  // headings
  "heading.text",
  "heading.title",

  // button
  "button.label",
  "button.href",

  // video
  "video.id",
  "video.filename_download",
] as const;

interface GoToVideoStoriesProps {
  data?: GoToVideoStoriesData;
}

export default function GoToVideoStories({ data }: GoToVideoStoriesProps) {
  if (!data?.published) return null;

  const videoUrl = data?.video?.id 
    ? `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/${data.video.id}` 
    : '';

  return (
    <section className="relative w-full overflow-hidden bg-white">
      {/* Main container */}
      <div className="py-0 lg:py-16 relative mx-auto">
        <div className="relative min-h-[37.5rem] lg:h-[48rem]">
          {/* Background image container */}
          <div className="absolute right-0 top-0 h-full w-full lg:w-[50%] 2xl:w-[60%] desktopFadeFromRight">
            <video
              src={videoUrl}
              className="object-cover w-full h-full lg:rounded-l-[32rem]"
              autoPlay
              muted
              loop
              playsInline
            />
            {/* Gradient overlay for mobile */}
            <div className="absolute inset-0 top-16 bg-gradient-to-b from-transparent to-primary opacity-70 lg:hidden" />
          </div>

          {/* Content */}
          <div className="absolute bottom-0 z-20 w-full px-8 lg:relative lg:z-10 lg:flex lg:h-full lg:flex-col lg:mt-0 lg:w-[40%] 2xl:w-[35%] lg:justify-center lg:pl-8 xl:pl-32 2xl:pl-56">
            <h2 className="font-essonnes text-[2rem] xl:text-6xl font-light leading-tight text-white lg:text-primary">
              {data?.heading?.text || data?.heading?.title}
            </h2>

            {/* Button */}
            <a href={data?.button?.href} className="mt-12 mb-12 lg:mb-0 inline-flex h-[4.375rem] w-full lg:w-fit items-center justify-center rounded-[3.125rem] px-9 text-xl font-normal tracking-tight text-white lg:bg-primary hover:bg-primary/90 border border-white lg:border-none">
              <span className="font-greycliff leading-7">
                {data?.button?.label}
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
} 